'use strict';

var Stringify = require('./stringify');
var Parse = require('./parse');

module.exports = {
    stringify: Stringify,
    parse: Parse
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/react-tiles/~/qs/lib/index.js
 ** module id = 247
 ** module chunks = 0
 **/